var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 14.0002H14.6667V8.66682H13.3333V14.0002H10.6667V8.66682H9.33333V14.0002H6.66667V8.66682H5.33333V14.0002H2.66667V8.66682H1.33333V14.0002H0.666667C0.298667 14.0002 0 14.2982 0 14.6668C0 15.0355 0.298667 15.3335 0.666667 15.3335H15.3333C15.7013 15.3335 16 15.0355 16 14.6668C16 14.2982 15.7013 14.0002 15.3333 14.0002Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6527 4.08149L8.31933 0.0814883C8.12 -0.0265117 7.88 -0.0265117 7.68067 0.0814883L0.347333 4.08149C0.133333 4.19815 0 4.42282 0 4.66682V6.66682C0 7.03549 0.298667 7.33349 0.666667 7.33349H15.3333C15.7013 7.33349 16 7.03549 16 6.66682V4.66682C16 4.42282 15.8667 4.19815 15.6527 4.08149ZM8 5.33349C7.26333 5.33349 6.66667 4.73682 6.66667 4.00015C6.66667 3.26349 7.26333 2.66682 8 2.66682C8.73667 2.66682 9.33333 3.26349 9.33333 4.00015C9.33333 4.73682 8.73667 5.33349 8 5.33349Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemple);
export default __webpack_public_path__ + "static/media/temple.c9cd158e.svg";
export { ForwardRef as ReactComponent };